import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const cards = [
  {
    icon: 'ri-brain-line',
    title: 'Programação Neurolinguística',
    desc: 'Técnicas comprovadas para reprogramar padrões mentais limitantes e criar novos caminhos neurais de sucesso e bem-estar duradouros.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Neurociência Aplicada',
    desc: 'Exercícios baseados em estudos científicos sobre neuroplasticidade, memória emocional e formação de hábitos de alta performance.',
  },
  {
    icon: 'ri-sparkling-line',
    title: 'Sabedoria Ancestral',
    desc: 'Meditação, gratidão e rituais de autoconhecimento que atravessam gerações, agora validados pela ciência moderna e aplicados na prática.',
  },
];

function Conceito() {
  return (
    <section className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(201,164,64,0.06),transparent_55%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(201,164,64,0.04),transparent_55%)]"></div>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/15 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10">
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-gold-500/60"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.35em] uppercase font-['Montserrat']">
                O Método
              </span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-gold-500/60"></div>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold mb-6 text-white leading-tight">
              Transformação Baseada em <span className="text-gold-400">Ciência</span>
            </h2>
            <p className="text-lg text-white/50 max-w-2xl mx-auto leading-relaxed font-['Montserrat'] font-light">
              Combinamos PNL, neurociência e práticas milenares em um método validado por milhares de vidas transformadas
            </p>
          </div>
        </ScrollRevealWrapper>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {cards.map((card, i) => (
            <ScrollRevealWrapper key={i} animation="fade-up" delay={0.1 * (i + 1)}>
              <div className="group relative bg-[#111111] border border-gold-500/10 rounded-2xl p-8 hover:border-gold-500/40 transition-all duration-500 hover:-translate-y-1 cursor-default">
                <div className="absolute inset-0 bg-gradient-to-br from-gold-500/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-gradient-to-br from-gold-500 to-gold-700 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500">
                    <i className={`${card.icon} text-2xl text-[#0a0a0a]`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-white mb-3 font-display leading-snug">{card.title}</h3>
                  <p className="text-white/50 leading-relaxed font-['Montserrat'] text-sm">{card.desc}</p>
                </div>
              </div>
            </ScrollRevealWrapper>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Conceito;
